import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

import ScreenManager from "../manager/ScreenManager";


// The screen manager
const screenManager = ScreenManager.instance;

export default class ScreenManagerComponent extends React.PureComponent {

    state = {
        screenProps: undefined,
        /** @type {{ title: string, message: string }} */
        error: null
    }

    /**
     * Implements the render function that is inherited from React.Component
     */
    render() {

        const showError = this.state.error !== null;

        // show navbar when a title is given
        return (

            <screenManager.currentScreenComponent {...this.state.screenProps}>

                <Modal onHide={showError ? this.state.error.onDissmiss() : () => {}} show={showError} >
                    <Modal.Header>{showError ? this.state.error.title : ""}</Modal.Header>
                    <Modal.Body>{showError ? this.state.error.message : ""}</Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={() => this.setState({ error: null })} >OK</Button>
                    </Modal.Footer>
                </Modal>

            </screenManager.currentScreenComponent>

        );
        
    }

    /**
     * Rerenders the screen and passes the given props to it.
     * @param {object} props The props to pass to the screen
     */
    changeScreen( props = undefined ) {
        if (!props) {
            this.forceUpdate();
            return;
        }

        this.setState({ screenProps: props });
    }

    /**
     * Shows a dialog with an error message
     * @param {string} title The title
     * @param {string} message The message
     * @param {function} onDissmiss Callback that gets called when the modal closes
     */
    showErrorModal( message, title, onDissmiss ) {

        let body = (
            <div>
                {message.split("\n").map( (text, i) => <span key={"mt"+i} >{text}<br/></span> )}
            </div>
        )

        this.setState({
            error: {
                title: title,
                message: body,
                onDissmiss: onDissmiss
            }
        });
        
    }

}